<template>
  <ul class="placement" :title="container.access">
    <template v-if="full">
      <li class="pill tier" :class="container.tier">{{ tier.label }}</li>
      <li class="pill exposure" :class="container.exposure">{{ exposure.label }}</li>
    </template>
    <li class="pill"><span class="pill-label">Port</span><code>{{ container.port === null || container.port === undefined ? '—' : container.port }}</code></li>
    <li v-if="container.exposure === 'gateway'" class="pill route"><span class="pill-label">Route</span><code>/{{ container.route }}</code></li>
    <li v-else-if="container.exposure === 'internal'" class="pill internal">Aucune route</li>
  </ul>
</template>

<script>
import {EXPOSURES, TIERS} from "@/administration/utils";

/**
 * Place d'un container dans l'architecture : son port et la route de la passerelle qui y mène (ou l'absence de route pour un container interne).
 * full : ajoute le niveau (front, passerelle, back) et l'exposition, pour les endroits où le container n'est pas dans sa zone.
 */
export default {
  name: 'ContainerPlacement',
  props: {
    container: {type: Object, required: true},
    full: {type: Boolean, default: false},
  },
  computed: {
    tier() {
      return TIERS[this.container.tier] ?? {label: this.container.tier};
    },
    exposure() {
      return EXPOSURES[this.container.exposure] ?? {label: this.container.exposure};
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.placement
  display flex
  flex-wrap wrap
  gap 6px
  margin 0
  padding 0
  list-style none

.pill
  display inline-flex
  align-items baseline
  gap 5px
  padding 2px 9px
  font-size 12px
  line-height 18px
  color #3f4a63
  background CTRL_BG
  border 1px solid CTRL_BORDER
  border-radius 999px

  code
    font-weight 600
    color THEME_COLOR_PRIMARY

.pill-label
  color CTRL_TEXT_MUTED

.route
  background #eef1f9
  border-color #c9d3ea

.internal
  color #5b6477
  background white
  border-style dashed
  border-color #9aa5bd

.tier
  font-weight 600
  color white
  background THEME_COLOR_PRIMARY_FADDED
  border-color transparent

  &.front
    background #2a8f8f

  &.gateway
    background THEME_COLOR_PRIMARY

.exposure.public
  background #e6f6f6
  border-color #b9e2e2

.exposure.gateway
  background #eef1f9
  border-color #c9d3ea

.exposure.internal
  background white
  border-style dashed
  border-color #9aa5bd
</style>
